import { placeholders, displayGroups } from '@ui';

import { TouchPointHelper } from '../../../helpers/touchPointHelper';

export const subscriptionIntegratorData = {
	prismName: 'subscriptionIntegratorData',
	template: {
		templateName: 'subscriptionIntegratorDataTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.lateralMenu, {
								placeholderBuildReference: 10,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[
							TouchPointHelper.createDisplayGroup(
								displayGroups.bodyPanel,
								[],
								[
									TouchPointHelper.createPlaceholder(placeholders.integratorData, {
										placeholderBuildReference: 20,
									}),
								]
							),
						],
						[
							TouchPointHelper.createPlaceholder(placeholders.fixedFooter, {
								placeholderBuildReference: 1000,
							}),
							TouchPointHelper.createPlaceholder(placeholders.modals, {
								placeholderBuildReference: 1001,
							}),
						]
					),
				]),
			]),
		],
	},
};
